import { render, staticRenderFns } from "./Publicacion.vue?vue&type=template&id=d687eb44"
import script from "./Publicacion.vue?vue&type=script&lang=js"
export * from "./Publicacion.vue?vue&type=script&lang=js"
import style0 from "./Publicacion.vue?vue&type=style&index=0&id=d687eb44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports